import React from 'react';
import Card from 'src/components/Card';
import { createUseStyles } from 'src/theming';
import ListItem from './components/ListItem';

const useStyles = createUseStyles({
  root: {
    minWidth: 165,
  },
  title: {
    fontWeight: 700,
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    paddingBottom: 8,
    paddingLeft: 8,
    color: 'rgb(33, 43, 54)',
  },
});

const StatsMenu = () => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <div className={classes.title}>Menu</div>
      <ListItem link='/dashboard/stats/reports' label='Rapport équipe commerciale' active />
      <ListItem link='/dashboard/stats' label='Commercial' />
      <ListItem link='/dashboard/stats/support' label='Support' />
    </Card>
  );
};

export default StatsMenu;
